<template>
  <div>
    <HeaderTop></HeaderTop>
    <div class="pay-success-page">
      <div class="success-container">
      <!-- 成功图标 -->
      <div class="success-icon">
        <i class="el-icon-success"></i>
      </div>
      
      <!-- 成功标题 -->
      <h1 class="success-title">支付成功</h1>
      
      <!-- 成功提示 -->
      <p class="success-tip">您的订单已支付成功，感谢您的使用！</p>
      
      <!-- 订单信息卡片 -->
      <!-- <div class="order-info-card">
        <div class="card-header">
          <h3>订单信息</h3>
        </div>
        <div class="card-body">
          <div class="info-row">
            <span class="label">订单编号：</span>
            <span class="value">{{ orderInfo.orderNo || '--' }}</span>
          </div>
          <div class="info-row">
            <span class="label">费用类型：</span>
            <span class="value">{{ orderInfo.yearTime ? `第${orderInfo.yearTime}学年助学培训费` : '--' }}</span>
          </div>
          <div class="info-row">
            <span class="label">支付金额：</span>
            <span class="value amount">￥{{ orderInfo.cost || orderInfo.money || '0.00' }}元</span>
          </div>
          <div class="info-row" v-if="orderInfo.createTime">
            <span class="label">创建时间：</span>
            <span class="value">{{ formatTime(orderInfo.createTime) }}</span>
          </div>
          <div class="info-row" v-if="orderInfo.payTime">
            <span class="label">支付时间：</span>
            <span class="value">{{ formatTime(orderInfo.payTime) }}</span>
          </div>
        </div>
      </div> -->
      
      <!-- 操作按钮 -->
      <!-- <div class="action-buttons">
        <el-button type="primary" size="medium" @click="goToOrder">查看订单</el-button>
        <el-button size="medium" @click="goToHome">返回首页</el-button>
      </div> -->
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import HeaderTop from "@/components/HeaderTop.vue";
import Footer from "@/components/Footer.vue";

export default {
  name: 'PaySuccess',
  components: {
    HeaderTop,
    Footer
  },
  data() {
    return {
      orderInfo: {}
    };
  },
  created() {
    // 从路由参数或query中获取订单信息
    if (this.$route.query.orderNo) {
      this.orderInfo = {
        orderNo: this.$route.query.orderNo,
        cost: this.$route.query.cost,
        money: this.$route.query.money,
        yearTime: this.$route.query.yearTime,
        createTime: this.$route.query.createTime,
        payTime: this.$route.query.payTime || new Date().toISOString()
      };
    } else if (this.$route.params.orderInfo) {
      this.orderInfo = this.$route.params.orderInfo;
    } else {
      // 如果没有传递订单信息，尝试从sessionStorage获取
      const savedOrderInfo = sessionStorage.getItem('paySuccessOrderInfo');
      if (savedOrderInfo) {
        try {
          this.orderInfo = JSON.parse(savedOrderInfo);
          sessionStorage.removeItem('paySuccessOrderInfo');
        } catch (e) {
          console.error('解析订单信息失败', e);
        }
      }
    }
  },
  methods: {
    formatTime(time) {
      if (!time) {
        return '--';
      }
      const timestamp = Date.parse(time);
      const date = new Date(timestamp);
      const YY = date.getFullYear();
      const MM =
        date.getMonth() + 1 < 10
          ? '0' + (date.getMonth() + 1)
          : date.getMonth() + 1;
      const DD = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
      const h = date.getHours() < 10 ? '0' + date.getHours() : date.getHours();
      const minute =
        date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes();
      const second =
        date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
      return `${YY}年${MM}月${DD}日 ${h}:${minute}:${second}`;
    },
    goToOrder() {
      this.$router.push({ name: 'order' });
    },
    goToHome() {
      this.$router.push({ name: 'home' });
    }
  }
};
</script>

<style lang="scss" scoped>
.pay-success-page {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px 20px 80px 20px;
  background: #f5f7fa;
  margin-top: 100px;
}

.success-container {
  max-width: 600px;
  width: 100%;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
  padding: 60px 40px;
  text-align: center;
}

.success-icon {
  margin-bottom: 30px;
  
  i {
    font-size: 80px;
    color: #67c23a;
  }
}

.success-title {
  font-size: 32px;
  font-weight: bold;
  color: #333;
  margin: 0 0 15px 0;
}

.success-tip {
  font-size: 16px;
  color: #666;
  margin: 0 0 40px 0;
}

.order-info-card {
  background: #f9f9f9;
  border-radius: 8px;
  margin-bottom: 40px;
  overflow: hidden;
  text-align: left;
}

.card-header {
  background: #e8f4f8;
  padding: 15px 20px;
  border-bottom: 1px solid #e0e0e0;
  
  h3 {
    margin: 0;
    font-size: 18px;
    font-weight: 600;
    color: #333;
  }
}

.card-body {
  padding: 20px;
}

.info-row {
  display: flex;
  align-items: center;
  padding: 12px 0;
  border-bottom: 1px solid #f0f0f0;
  
  &:last-child {
    border-bottom: none;
  }
  
  .label {
    width: 100px;
    font-size: 14px;
    color: #666;
    flex-shrink: 0;
  }
  
  .value {
    font-size: 14px;
    color: #333;
    flex: 1;
    
    &.amount {
      color: #f56c6c;
      font-size: 18px;
      font-weight: bold;
    }
  }
}

.action-buttons {
  display: flex;
  justify-content: center;
  gap: 20px;
  
  .el-button {
    min-width: 120px;
    padding: 12px 30px;
    font-size: 16px;
  }
}

@media (max-width: 768px) {
  .success-container {
    padding: 40px 20px;
  }
  
  .success-icon i {
    font-size: 60px;
  }
  
  .success-title {
    font-size: 24px;
  }
  
  .action-buttons {
    flex-direction: column;
    
    .el-button {
      width: 100%;
    }
  }
}
</style>
